import { LoadingOutlined, WarningOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Result, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetUnitHeadPositionsApi from "../../../api/GetUnitHeadPositionsApi";
import AddUnitHeadApi from "../../../api/units/AddUnitHeadApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import PageLoader from "../../sub/PageLoader";

const { Option } = Select;

function AddEditUnitHeadModal(props) {
  const [unitHeads, setUnitHeads] = useState();
  const [submit, setSubmit] = useState(false);
  let navigate = useNavigate();

  function handleCancel() {
    setUnitHeads();
    setSubmit(false);
    props.handleCancel();
  }

  useEffect(() => {
    if (props.visible) {
      getUnitHeadPositions();
    }
  }, [props.visible]);

  async function getUnitHeadPositions() {
    const apiResponse = await GetUnitHeadPositionsApi(props.unit?.id);
    if (apiResponse.message === "success") {
      setUnitHeads(apiResponse?.data);
    }
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await AddUnitHeadApi(props.unit?.id, value.unitHead);

    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "UnitHead added successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add unit head. Try again later."
      );
    }
    setSubmit(false);
    handleCancel();
  }

  function showAddUsers() {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">Add position</div>
          <div className="mb-3 text-gray-400">
            You must add positions for this level before adding unit head
          </div>
          <Button
            onClick={() => {
              navigate("/settings/positions");
              handleCancel();
            }}
            type="primary"
          >
            Add position
          </Button>
        </div>
      </div>
    );
  }

  return (
    <Modal
      title="Add unit head"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      {unitHeads ? (
        !!unitHeads.length ? (
          <Form
            name="addUnit"
            onFinish={onFinish}
            layout="vertical"
            requiredMark={false}
            autoComplete="off"
          >
            <div className="">Unit</div>
            <div className="font-bold mb-3">{props.unit?.name}</div>

            <Form.Item
              label="Unit Head"
              name="unitHead"
              rules={[
                {
                  required: true,
                  message: "Please select a level!",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Unit Head"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
              >
                {unitHeads.map((unitHead) => {
                  return (
                    <Option key={unitHead.id} value={unitHead.id}>
                      {(unitHead?.user?.id
                        ? unitHead?.user?.firstName +
                          " " +
                          unitHead?.user?.lastName +
                          ", "
                        : "") + unitHead?.designation?.abbreviation}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>

            <Form.Item style={{ marginBottom: 0 }}>
              <div className=" flex justify-end">
                <Button className="mr-3 w-28" onClick={() => handleCancel()}>
                  Cancel
                </Button>
                <Button
                  className="btn w-32"
                  type="primary"
                  htmlType={submit && "submit"}
                  disabled={submit}
                >
                  {submit ? (
                    <Spin
                      size="small"
                      indicator={
                        <LoadingOutlined style={{ color: "#fff" }} spin />
                      }
                    />
                  ) : (
                    "Add"
                  )}
                </Button>
              </div>
            </Form.Item>
          </Form>
        ) : (
          showAddUsers()
        )
      ) : (
        <PageLoader />
      )}
    </Modal>
  );
}

export default AddEditUnitHeadModal;
